import { Grid, Typography, List, ListItem, Stack } from "@mui/material";
import { useEffect } from "react";
import { useStoreContext } from "../..";
import { observer } from "mobx-react";
import dayjs from "dayjs";
import { Measurement } from "../../models/Measurements";
import EditButton from "../EditButton";

const VaccinationDayList = observer(
  ({ onClick }: { onClick: (day: Measurement) => void }) => {
    const { measurementStore, fieldStore } = useStoreContext();

    useEffect(() => {
      if (!measurementStore.vaccinations) {
        measurementStore.getVaccinations();
      }
    }, [measurementStore.vaccinations]);

    useEffect(() => {
      if (!fieldStore.fields) {
        fieldStore.getFields();
      }
    }, [fieldStore.fields]);

    const vaccinations = measurementStore.vaccinations;

    if (!vaccinations || !fieldStore.mappedVaccines) {
      return null;
    }

    return (
      <List dense>
        {vaccinations.map((vac, index) => (
          <ListItem key={index} sx={{ padding: 1 }}>
            <Grid
              container
              sx={{ borderBottom: "1px solid lightgrey", paddingBottom: 1.5 }}
              spacing={2}
            >
              <Grid item xs={12} sm={3}>
                <Stack direction="column">
                  <Typography>
                    {dayjs(vac.date).format("YYYY-MM-DD")}
                  </Typography>
                  <EditButton onClick={() => onClick(vac as Measurement)} />
                </Stack>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Typography>
                  {fieldStore.mappedVaccines?.get(Number(vac.value)) ||
                    vac.value}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    );
  }
);

export default VaccinationDayList;
